<template>
  <v-sheet class="pa-2">
    <v-row>
      <v-col cols="4">
        <v-select
          :items="types"
          label="TimeFrame"
          dense
          :value="view"
          @change="resetCron"
          outlined
        >
        </v-select>
      </v-col>
      <v-col>
        <h5>Time Phrase:</h5>
        <div class="timeFrame pt-1">"{{ timePhrase }}"</div>
      </v-col>
    </v-row>
    <section class="px-3">
      <v-row v-if="view == 'minute'">
        <v-col cols="auto" class="pa-1">Every </v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="1"
            max="59"
            :value="minute"
            @input="setDigit(0, $event)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">minute(s)</v-col>
      </v-row>
      <v-row v-if="view == 'hour'">
        <v-col cols="auto" class="pa-1">Every </v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="1"
            max="24"
            :value="hour"
            @input="setDigit(1, $event)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">hour(s) on the </v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="0"
            max="59"
            :value="minute"
            @input="setDigit(0, $event, false)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">
          <span class="font-italic">th</span> minute
        </v-col>
      </v-row>
      <v-row v-if="view == 'day'">
        <v-col cols="auto" class="pa-1">Every </v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="1"
            max="365"
            :value="day"
            @input="setDigit(2, $event)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">day(s) at</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="00"
            max="23"
            :value="hour"
            @input="setDigit(1, $event, false)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">:</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="0"
            max="59"
            :value="minute"
            @input="setDigit(0, $event, false)"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="view == 'week'">
        <v-col cols="auto" class="pa-1">Every </v-col>
        <v-col cols="3" class="py-0 px-1">
          <v-select
            :value="week"
            :items="weekDays"
            label="Select Days"
            dense
            multiple
            @change="setDigit(4, $event)"
          >
          </v-select>
        </v-col>
        <v-col cols="auto" class="pa-1">day(s) at</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="0"
            max="23"
            :value="hour"
            @input="setDigit(1, $event, false)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">:</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="0"
            max="60"
            :value="minute"
            @input="setDigit(0, $event, false)"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="view == 'month'">
        <v-col cols="auto" class="pa-1">On the</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="1"
            max="30"
            :value="day"
            @input="setDigit(2, $event, false)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">
          <span class="font-italic">th</span> day of every
        </v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="0"
            max="9999"
            :value="month"
            @input="setDigit(3, $event)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">month(s) at</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            :value="hour"
            min="0"
            max="23"
            @input="setDigit(1, $event, false)"
          >
          </v-text-field>
        </v-col>
        <v-col cols="auto" class="pa-1">:</v-col>
        <v-col cols="1" class="py-0 px-1">
          <v-text-field
            type="number"
            dense
            min="0"
            max="60"
            :value="minute"
            @input="setDigit(0, $event, false)"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </section>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import cronstrue from "cronstrue";

export default Vue.extend({
  name: "CronComp",

  data() {
    return {
      types: [
        { text: "Minutes", value: "minute" },
        { text: "Hourly", value: "hour" },
        { text: "Daily", value: "day" },
        { text: "Weekly", value: "week" },
        { text: "Monthly", value: "month" },
        // { text: "Advanced", value: "custom" },
      ],
      weekDays: [
        { text: "Sunday", value: 0 },
        { text: "Monday", value: 1 },
        { text: "Tuesday", value: 2 },
        { text: "Wednesday", value: 3 },
        { text: "Thursday", value: 4 },
        { text: "Friday", value: 5 },
        { text: "Saturday", value: 6 },
      ],
    };
  },
  props: {
    cron: VueTypes.string, // month view default
  },
  computed: {
    timePhrase(): string {
      return cronstrue.toString(this.cronSet.join(" "));
    },
    view: {
      get(): string {
        let view = "month";
        for (const i in this.cronSet) {
          if (this.cronSet[i].includes("/") || this.cronSet[i].includes(",")) {
            switch (i) {
              case "0":
                view = "minute";
                break;
              case "1":
                view = "hour";
                break;
              case "2":
                view = "day";
                break;
              case "3":
                view = "month";
                break;
              case "4":
                view = "week";
                break;
            }
          }
        }
        return view;
      },
      set(view: string) {
        return view;
      },
    },
    minute: {
      get(): number {
        return this.parseDigit(this.cronSet[0], "minute");
      },
      set(val: number) {
        this.setDigit(0, this.parseDigit(String(val || 0), "minute"), false);
      },
    },
    hour: {
      get(): number {
        return this.parseDigit(this.cronSet[1], "hour");
      },
      set(val: number) {
        this.setDigit(1, this.parseDigit(String(val || 0), "hour"), false);
      },
    },
    day: {
      get(): number {
        return this.parseDigit(this.cronSet[2], "day");
      },
      set(val: number) {
        this.setDigit(2, this.parseDigit(String(val || 0), "day"), false);
      },
    },
    month: {
      get(): number {
        return this.parseDigit(this.cronSet[3], "month");
      },
      set(val: number) {
        this.setDigit(3, this.parseDigit(String(val || 0), "month"), false);
      },
    },
    week: {
      get(): number | number[] {
        return this.parseDigit(this.cronSet[4], "week", true);
      },
      set(val: number) {
        this.setDigit(4, this.parseDigit(String(val || 0), "week"), false);
      },
    },
    cronSet(): string[] {
      return this.cron.split(" ");
    },
  },
  methods: {
    updateCron(cronSet: string[]): void {
      const cron = cronSet.join(" ");
      this.$emit("changed", { cron, timePhrase: cronstrue.toString(cron) });
    },
    resetCron(view: string): void {
      let cron = ["*", "*", "*", "*", "*"];
      switch (view) {
        case "minute":
          cron = ["*/1", "*", "*", "*", "*"];
          break;
        case "hour":
          cron = ["0", "*/1", "*", "*", "*"];
          break;
        case "day":
          cron = ["0", "0", "*/1", "*", "*"];
          break;
        case "week":
          cron = ["0", "0", "*", "*", "0"];
          break;
        case "month":
          cron = ["0", "0", "1", "*/1", "*"];
          break;

        default:
          cron = ["*", "*", "*", "*", "*"];
          break;
      }

      this.updateCron(cron);
    },
    parseDigit(digit: string, view: string, list = false): number | number[] {
      let val: number | number[] = +digit || 0;

      if (digit.includes("/")) {
        this.view = view;
        val = +digit.split("/")[1];
      }
      if (digit.includes(",")) {
        this.view = view;
        val = digit.split(",").map((s: string | number) => +s);
      }
      if (list && !Array.isArray(val)) {
        val = [val];
      }
      return val;
    },
    setDigit(pos: number, value: string | string[], every = true) {
      const cron = [...this.cronSet];
      let val: string | string[] | number | number[] = value;
      if (Array.isArray(val)) {
        if (val.length) {
          val = val.join();
        } else {
          val = "*";
        }
      } else {
        val = +val;
        if (!val || val <= 0) {
          val = 0;
        }
        if (every) {
          val = val > 0 ? `*/${val}` : "*";
        }
      }
      cron[pos] = val;
      this.updateCron(cron);
    },
  },
});
</script>
<style scoped>
.timeFrame {
  color: teal;
  font-weight: normal;
}
input[type="number"] {
  text-align: center !important;
}
</style>
